/**
 * Shell for every Texas registry route (F-289/F-290/F-291).
 *
 * Before this, App.tsx rendered each /texas/* page component BARE — no
 * navbar — so clicking any submenu item landed on a page with zero
 * navigation: no menu on top, nothing to do but the browser Back button
 * (the human's "dead end" report, 2026-10-06). The dashboard had the menu;
 * child pages lost it on navigation.
 *
 * This shell renders the same MarketAwareNavbar the dashboard uses (which
 * mounts TexasGroupedSidebar on the texas market) above the page component.
 */
import React from 'react';
import MarketAwareNavbar from '../components/Dashboard/components/MarketAwareNavbar';

const TexasRouteShell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className="min-h-screen bg-gray-50">
        <MarketAwareNavbar />
        <main id="main-content">{children}</main>
    </div>
);

export { TexasRouteShell };
export default TexasRouteShell;
